import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { ArchivedPeoplePage } from '@/features/settings/ui/ArchivedPeoplePage';

export const Route = createFileRoute('/_authenticated/archive/people')({ validateSearch: z.object({ s: sortSearchParam }), component: ArchivedPeoplePage });
